import SwapRoom from './SwapRoom'


export default SwapRoom
